import logger from '../utils/logger';
import { ensureTrailingSlash } from '../utils/urlHelper';
import { AxiosRequestConfig } from 'axios';
import { ApiServiceBase as HttpBase } from 'copyright-clearance-center-common-ui-react';

export default class ApiServiceBase extends HttpBase {
	constructor(basePath: string) {
		super(basePath, logger);
	}

	protected createBaseRequest(): AxiosRequestConfig {
		return {
			...super.createBaseRequest(),
			baseURL: window.location.origin + ensureTrailingSlash(this.basePath),
			timeout: 1000 * 60
		};
	}
}
